// doc: https://nhnent.github.io/tui.editor/api/latest/ToastUIEditor.html#ToastUIEditor
export default {
  height: "300px",
  previewStyle: "tab",
  initialEditType: 'markdown',
  useCommandShortcut: true,
  useDefaultHTMLSanitizer: true,
  usageStatistics: false,
  autofocus: false,
  hideModeSwitch: false,
};
